module.exports = __webpack_public_path__ + "static/media/logo-full.8e51b4cc.svg";